document.querySelectorAll('.hambcoll').forEach(function (element) {
  element.addEventListener('click', function () {
    const menu = document.querySelector('.hamburger-coll');
    if (menu) {
      menu.style.position = 'fixed';
      menu.style.display = 'block';
      menu.classList.add('active');
    }
  });
});

// Close button functionality
document.querySelectorAll('.close-hamburger-stk').forEach(function (closeButton) {
  closeButton.addEventListener('click', function () {
    const menu = document.querySelector('.hamburger-coll');
    if (menu) {
      menu.style.display = 'none';  // Hide the menu
      
        menu.classList.remove('active');  // Remove the active class after the menu is hidden
     
    }
  });
});

document.addEventListener("DOMContentLoaded", function(){
    document.querySelectorAll('.new-navv-src').forEach(function(element) {
      element.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          document.querySelectorAll('[data-live-search-input]').forEach(function(inputElement) {
              var event = new Event('keyup');
              inputElement.dispatchEvent(event);
          });
      });
    });
    window.addEventListener('cartcount:update', function() {
      setTimeout(function(){
        var item_count = Number(document.querySelector(".site-header .site-header-cart--count").getAttribute("data-header-cart-count"));
        console.log(item_count);
        if(item_count > 0){
          if(document.querySelector(".new-sticky-nav .site-header-cart--count").classList.contains("visible") == false ){
            document.querySelector(".new-sticky-nav .site-header-cart--count").classList.add("visible");
          }
          document.querySelector(".new-sticky-nav .site-header-cart--count").setAttribute("data-header-cart-count", item_count);
        }else{
          document.querySelector(".new-sticky-nav .site-header-cart--count").classList.remove("visible");
        }
      }, 20);
    });
  });


document.addEventListener("DOMContentLoaded", function() {
    let menuItems = document.querySelectorAll(".menu-item");
    let submenuContents = document.querySelectorAll(".submenu-content");
    let activeMenuItem = null; // Store the active menu item reference

    menuItems.forEach(item => {
        item.addEventListener("click", function() {
            let menuIndex = this.getAttribute("data-menu");

            if (activeMenuItem === this) {
                // If the same menu item is clicked again, do nothing
                return;
            }

            activeMenuItem = this; // Update active menu item
            
            menuItems.forEach(i => i.classList.remove("active"));
            this.classList.add("active");

            submenuContents.forEach(sub => {
                if (sub.getAttribute("data-submenu") === menuIndex) {
                    sub.style.display = "flex"; // Show submenu immediately
                    setTimeout(() => {
                        sub.classList.add("open");
                    }, 10);
                } else {
                    sub.classList.remove("open");
                    sub.style.display = "none"; // Hide instantly
                }
            });
        });
    });
});

fetch('/pages/menu-footer-json')
  .then(res => res.json())
  .then(data => {
    const menuList = document.querySelector('.menu-list');
    const submenuList = document.querySelector('.submenu-list');

    menuList.innerHTML = data.items.map((item, index) => `
      <div class="menu-item${index === 0 ? ' active' : ''}" data-menu="${index + 1}">
        ${item.image ? `<img class="collection_image coll-img-ftmenu" src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
        <span class="menu-item--ttl">${item.title}</span>
      </div>
    `).join('');

    submenuList.innerHTML = data.items.map((item, index) => {
      if (!item.children || item.children.length === 0) return '';
      return `
        <div class="submenu-content${index === 0 ? ' open' : ''}" data-submenu="${index + 1}">
          <h2 class="submenu-menu-item--ttl">${item.title}</h2>
          ${item.children.map(sub => `
            <a href="${sub.url}" class="submenu-item${sub.current ? ' submenu-cuurent' : ''}" ${sub.current ? 'aria-current="page"' : ''}>
              ${sub.image ? `<img class="collection_image" src="${sub.image}" alt="${sub.title}" loading="lazy">` : ''}
              <span class="submenu-item-ttl">${sub.title}</span>
            </a>
          `).join('')}
        </div>
      `;
    }).join('');
    initMenuFooterListeners();
  });
function initMenuFooterListeners() {
 let menuItems = document.querySelectorAll(".menu-item");
    let submenuContents = document.querySelectorAll(".submenu-content");
    let activeMenuItem = null; // Store the active menu item reference

    menuItems.forEach(item => {
        item.addEventListener("click", function() {
            let menuIndex = this.getAttribute("data-menu");

            if (activeMenuItem === this) {
                // If the same menu item is clicked again, do nothing
                return;
            }

            activeMenuItem = this; // Update active menu item
            
            menuItems.forEach(i => i.classList.remove("active"));
            this.classList.add("active");

            submenuContents.forEach(sub => {
                if (sub.getAttribute("data-submenu") === menuIndex) {
                    sub.style.display = "flex"; // Show submenu immediately
                    setTimeout(() => {
                        sub.classList.add("open");
                    }, 10);
                } else {
                    sub.classList.remove("open");
                    sub.style.display = "none"; // Hide instantly
                }
            });
        });
    });
}